import { RankingsComponent } from './components/RankingsComponent.js';
import { RankingsService } from './services/RankingsService.js';
import { RankingsState } from './state/RankingsState.js';

let rankingsInstance = null;

export async function initRankings(container, options = {}) {
  if (rankingsInstance) return rankingsInstance;

  const rankingsState = new RankingsState();
  const rankingsService = new RankingsService(rankingsState);
  window.rankingsService = rankingsService;

  const rankingsComponent = new RankingsComponent(container, {
    state: rankingsState,
    service: rankingsService,
    ...options
  });

  rankingsInstance = rankingsComponent;
  window.__getRankingsComponent = () => rankingsComponent;
  return rankingsComponent;
}
